import React, { Component } from "react";
import { connect } from "react-redux";
import { converDateIntoLocal } from "../../../../../../common/common-functions";
import _ from "lodash";
import { ProductTextLocalized } from "../../../../../../common/common-functions";
import {
  currencyCode,
  currencyRate,
  isCurrencyRateApplicable,
} from "../../../../currency/action/index";

class PendingNegoitems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  render() {
    var { values, language, localCurrency } = this.props;
    //  console.log('rejected',values)
    let currency = currencyCode(localCurrency);
    let currencyrate = currencyRate(localCurrency);

    let tabledate = "";
    tabledate = converDateIntoLocal(values.createdon).format(
      "D MMM YYYY HH:mm A"
    );
    return (
      <>
        <tr className="bg-white border-b-2 border-gray-50 cursor-pointer hover-all">
          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 ">
            {ProductTextLocalized(
              values.productdetail.productname_en,
              values.productdetail.productname_ar,
              language
            )}

            <div>
              {values.productdetail.hasvariant == "1" ? (
                <span>Variant: {values.productdetail.variant.name_en}</span>
              ) : (
                ""
              )}
            </div>
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
            {/* ${parseFloat(values.originalprice).toFixed(2)} */} {currency}{" "}
            {values.originalprice}
          </td>

          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
            {/* ${parseFloat(values.price).toFixed(2)} */} {currency}{" "}
            {values.price}
          </td>
        </tr>
      </>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var { session, user } = state;
  // console.log('customerlistingtabs',state.customerlistingtabs);
  return {
    session,
    user,
    isLoggedIn: state.isLoggedIn,
    language: state.language,
    localCurrency: state.currency,
  };
}
export default connect(mapStateToProps, {
  isCurrencyRateApplicable,
})(PendingNegoitems);
